export default "__VITE_ASSET__DO$QRy9$__"